import { isEmpty } from "./data_manipulator";


export function removeStrSpace(str: string): string {
  
  if(!str) return "";
  str = str.replaceAll(" ", "")
  return str.trim();
}


export function removeFilenameExtension(filename: string | undefined): string {
  if (!filename) return "";
  return filename.replace(/\.[^/.]+$/, "");
}

export function toTitleCase(value: string): string {
  if (!value) return "";
  return value.replace(/\w\S*/g, (txt) => {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

export function TruncateText(text: string | null | undefined, maxLength: number): string {

  if (isEmpty(text)) return ""
  if (typeof text !== "string" || text.length <= maxLength) {
    return text!;
  }
  return text.slice(0, maxLength) + "...";
}



export function addSpaceBetweenWords(str: string): string {
  if (!str) return "";

  return str
    // 1. Insert space between lowercase and uppercase (Standard camelCase)
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    // 2. Insert space between two uppercase letters if followed by lowercase (Acronyms)
    // Example: "OEAction" -> "OE Action"
    .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
    // 3. Optional: Add space before special characters/numbers if needed
    .replace(/([a-zA-Z])([\d#@$!%*?&])/g, '$1 $2') 
    .replace(":", ": ")
    .trim();
}


export function getTextSegment(
  text: string, 
  separator: string = " ", 
  getLast: boolean = false
): string {
  if (!text) return "";

  if (getLast) {
    const index = text.lastIndexOf(separator);
    return index === -1 ? text : text.slice(index + separator.length);
  } else {
    const index = text.indexOf(separator);
    return index === -1 ? text : text.slice(0, index);
  }
}